AgrimarketServices.service('conditionsService', ['$http', 'configurationFactory', 'editableObjectsFactory', '$rootScope', '$filter',
    function ($http, configurationFactory, editableObjectsFactory, $rootScope, $filter) {

        var SendRequest = function (configfile, callback) {
            $http(configfile)
                .success(function (data) {
                    callback(data, null);
                })
                .error(function (data, status) {
                    callback(data, status);
                });
        };

        var _getUserGroupConditionsOfTree = function (idOffer, idExpiry, idVariety, callback) {
            var config = {
                method: 'GET',
                url: configurationFactory.Url['Api'] + 'Tree/GetUserGroupConditionsOfTree',
                params: { idOffer: idOffer, idExpiry: idExpiry, idVariety: idVariety }
            };
            SendRequest(config, callback);
        };

        var _getUserGroupConditionsChild = function (idTreeCondition, idOffer, idExpiry, idVariety, callback) {
            var config = {
                method: 'GET',
                url: configurationFactory.Url['Api'] + 'Tree/GetUserGroupConditionsChild',
                params: { idTreeCondition: idTreeCondition, idOffer: idOffer, idExpiry: idExpiry, idVariety: idVariety }
            };
            SendRequest(config, callback);
        };

        var _recursifCheckAndSetGroupConditions = function (lstGroupConditions, objError, tabSelectedValues) {
            if (lstGroupConditions && lstGroupConditions.length > 0) {
                lstGroupConditions.every(function (element) {
                    // Gestion des groupes en saisie libre
                    if (element.IdTypeFreeInput) {
                        if (!element.TextFreeInput) {
                            objError.text = editableObjectsFactory.EditableObjects.Error_OfferSubscribe_PleaseSelectAllConditions.Content;
                        } else if (element.IdTypeFreeInput === $rootScope.enumFactory.TypeFreeInputs.Numeric && isNaN(element.TextFreeInput.replace(',', '.'))) {
                            objError.text = editableObjectsFactory.EditableObjects.Error_OfferSubscribe_GroupFreeInput_ValueMustBeNumeric.Content.replace("[group]", element.Label);
                        }
                        else {
                            tabSelectedValues.push({ IdTreeGroupCondition: element.IdTreeGroupCondition, Visible: true, Value: 0, GrpLabel: element.Label, Label: element.TextFreeInput, LabelToDisplay: element.TextFreeInput, IdGroupCondition: element.IdGroupCondition, AutoComplete: false });
                        }
                        return true;
                    }
                    // Gestion des groupes en liste déroulante
                    if (!element.selectedValue || element.selectedValue.Value <= 0) {
                        objError.text = editableObjectsFactory.EditableObjects.Error_OfferSubscribe_PleaseSelectAllConditions.Content;
                    } else {
                        var selectedOption = element.LstOptions.filter(function (option) { return option.IdTreeCondition === Number(element.selectedValue); })[0];
                        var selectedOptionAutoComplete = element.LstOptions.filter(function (option) { return option.Label === element.selectedValue; })[0];
                        if (selectedOption != null && selectedOption != undefined)
                            tabSelectedValues.push({ IdTreeGroupCondition: element.IdTreeGroupCondition, IdTreeCondition: Number(element.selectedValue), Visible: selectedOption.Visible, Value: selectedOption.Value, GrpLabel: element.Label, Label: selectedOption.Label, LabelToDisplay: selectedOption.LabelToDisplay, IdGroupCondition: element.IdGroupCondition, AutoComplete: element.AutoComplete });
                        else if (selectedOptionAutoComplete != null && selectedOptionAutoComplete != undefined)
                            tabSelectedValues.push({ IdTreeGroupCondition: element.IdTreeGroupCondition, IdTreeCondition: selectedOptionAutoComplete.IdTreeCondition, Visible: selectedOptionAutoComplete.Visible, Value: selectedOptionAutoComplete.Value, GrpLabel: element.Label, Label: selectedOptionAutoComplete.Label, LabelToDisplay: selectedOptionAutoComplete.LabelToDisplay, IdGroupCondition: element.IdGroupCondition, AutoComplete: element.AutoComplete });
                        _recursifCheckAndSetGroupConditions(element.LstConditionParticularsChilds, objError, tabSelectedValues);
                    }
                    return true;
                });
            }
        };

        var _conditionParticularsOnChange = function (idOffer, groupCondPart, preSelectedConditions, idExpiry, idVariety, recursiveUpdateSimulatorPrices) {
            groupCondPart.LstConditionParticularsChilds = [];
            if (recursiveUpdateSimulatorPrices)
                recursiveUpdateSimulatorPrices();

            if (groupCondPart.selectedValue > 0) {
                _getUserGroupConditionsChild(groupCondPart.selectedValue, idOffer, idExpiry, idVariety, function (data, status) {
                    if (status !== null) {
                        if (status === 400)
                            return data[0].errors[0].Message;
                    } else {
                        groupCondPart.LstConditionParticularsChilds = data;
                        _manageGroupPrefill(groupCondPart.LstConditionParticularsChilds, preSelectedConditions, idOffer, idExpiry, idVariety, recursiveUpdateSimulatorPrices);
                    }
                });
            }
        };

        var _manageGroupPrefill = function (conditionParticulars, preSelectedConditions, idOffer, idExpiry, idVariety, recursiveUpdateSimulatorPrices) {
            conditionParticulars.forEach(function (group) {
                group.LstOptions.forEach(function (condition) {
                    condition.LabelToDisplay = condition.Visible ? condition.Label + ' (' + condition.Value + ' ' + $rootScope.globalLabels.Currency + ')' : condition.Label;
                });
                if (preSelectedConditions) { // Conditions venant du meilleur chemin de condPart, d'un engagement ou d'une première composante.
                    var infoCondPartInGroup = $filter('filter')(preSelectedConditions, { IdTreeGroupCondition: group.IdTreeGroupCondition }, true)[0];
                    if (infoCondPartInGroup) // On pré-selectionne la condPart, et on va chercher ses fils, si il sagit d'un Autocomplete, on set avec le label car ce n'est pas un select, c'est un input le remplissage est différent
                        if (!group.IdTypeFreeInput)
                            group.selectedValue = !group.AutoComplete ? infoCondPartInGroup.IdTreeCondition : infoCondPartInGroup.Label; // S'il s'agit d'un Autocomplete, on set avec le label car ce n'est pas un select, c'est un input le remplissage est différent
                        else
                            group.TextFreeInput = infoCondPartInGroup.Label;
                }
                else if (!group.IdTypeFreeInput) {
                    if (!group.Hidden)
                        group.LstOptions.unshift({
                            "IdTreeCondition": 0,
                            "Label": "Sélectionnez..",
                            "LabelToDisplay": "Sélectionnez..",
                            "Value": 0,
                            "Visible": false
                        });
                    group.selectedValue = group.LstOptions[0].IdTreeCondition;
                }
                if (group.selectedValue)
                    _conditionParticularsOnChange(idOffer, group, preSelectedConditions, idExpiry, idVariety, recursiveUpdateSimulatorPrices);
            });
        };

        this.GetTreesForSelect = function (callback) {
            var config = {
                method: 'GET',
                url: configurationFactory.Url['Api'] + 'Tree/GetTreesForSelect',
            };
            SendRequest(config, callback);
        };

        this.GetTrees = function (callback) {
            var config = {
                method: 'GET',
                url: configurationFactory.Url['Api'] + 'Tree/GetTrees',
            };
            SendRequest(config, callback);
        };

        this.SaveTree = function (tree, callback) {
            var config = {
                method: 'POST',
                url: configurationFactory.Url['Api'] + 'Tree/SaveTree',
                data: tree
            };
            SendRequest(config, callback);
        };

        this.DeleteTree = function (idTree, callback) {
            var config = {
                method: 'PUT',
                url: configurationFactory.Url['Api'] + 'Tree/DeleteTree',
                params: { idTree: idTree }
            };
            SendRequest(config, callback);
        };

        this.GetGroupConditions = function (callback) {
            var config = {
                method: 'GET',
                url: configurationFactory.Url['Api'] + 'GroupCondition/GetGroupConditions'
            };
            SendRequest(config, callback);
        };

        this.SaveGroupConditions = function (groups, callback) {
            var config = {
                method: 'POST',
                url: configurationFactory.Url['Api'] + 'GroupCondition/SaveGroupConditions',
                data: groups
            };
            SendRequest(config, callback);
        };

        this.CheckAndSetGroupConditions = function (lstGroupConditions, tabSelectedValues) {
            var objError = { text: "" };

            if (lstGroupConditions && lstGroupConditions.length > 0)
                _recursifCheckAndSetGroupConditions(lstGroupConditions, objError, tabSelectedValues);

            return objError.text;
        };

        this.GetCondParts = function (idOffer, idTree, preSelectedConditions, idExpiry, idVariety, recursiveUpdateSimulatorPrices, callback) {
            var res = {
                errorMessage: "",
                conditionParticulars: null
            };
            if (idTree) {
                _getUserGroupConditionsOfTree(idOffer, idExpiry, idVariety, function (data, status) {
                    if (status !== null) {
                        if (status === 400) {
                            res.errorMessage = data[0].errors[0].Message;
                        }
                    } else {
                        res.conditionParticulars = data;
                        _manageGroupPrefill(res.conditionParticulars, preSelectedConditions, idOffer, idExpiry, idVariety, recursiveUpdateSimulatorPrices);
                    }
                    callback(res);
                    return;
                });
            }
            else if (recursiveUpdateSimulatorPrices)
                recursiveUpdateSimulatorPrices();
        };

        this.ConditionParticularsOnChange = function (idOffer, condition, idExpiry, idVariety, recursiveUpdateSimulatorPrices) {
            _conditionParticularsOnChange(idOffer, condition, null, idExpiry, idVariety, recursiveUpdateSimulatorPrices);
        };

        this.GetTotalLstGroupConditionsSelectedValues = function (lstGroupConditionsSelectedValues) {
            var total = 0;

            if (lstGroupConditionsSelectedValues) {
                lstGroupConditionsSelectedValues.forEach(function (item) {
                    if (item && item.Value)
                        total += item.Value;
                });
            }

            return total;
        };

        this.GetBestPath = function (idOffer, idExpiry, idVariety, callback) {
            var config = {
                method: 'GET',
                url: configurationFactory.Url['Api'] + 'Tree/GetOfferBestPath',
                params: { idOffer: idOffer, idExpiry: idExpiry, idVariety: idVariety }
            };
            SendRequest(config, callback);
        };

        this.GetContractCondParts = function (idContract, callback) {
            var config = {
                method: 'GET',
                url: configurationFactory.Url['Api'] + 'Tree/GetContractCondParts',
                params: { idContract: idContract }
            };
            SendRequest(config, callback);
        };

        this.GetTypeFreeInputs = function (callback) {
            var config = {
                method: 'GET',
                url: configurationFactory.Url['Api'] + 'GroupCondition/GetTypeFreeInputs'
            };
            SendRequest(config, callback);
        };
    }]);